import { Stack } from 'expo-router';

export default function TrailSlugLayout() {
  return (
    <Stack screenOptions={{ headerShown: false }}>
      <Stack.Screen name="index" options={{ animation: 'slide_from_right' }} />
      <Stack.Screen name="[stepNumber]" options={{ animation: 'slide_from_right' }} />
    </Stack>
  );
}
